<template>
  <div v-loading="$wait.waiting(_uid)" />
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("userStore", ["user"]),
    isTrainee() {
      return this.user.acl.isTrainee;
    },
  },
  mounted() {
    try {
      this.$wait.start(this._uid);
      if (this.isTrainee) {
        return this.$router.push({
          name: "my@training",
        });
      }

      return this.$router.push({
        name: "dashboard",
      });
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
  },
};
</script>

<style lang="scss" scoped></style>
